import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import api from "../../../services/api";
import dayjs from "dayjs";

export async function memberReport(filtro: any, club: any) {
    const response = await api.post(`/api/athletes/report`, { filtro })
    const athletes: any[] = response.data

    const workbook = new ExcelJS.Workbook();
    const ws = workbook.addWorksheet("carga_associados");

    ws.columns = [
        { header: "ORD NUMÉRICA", key: "ord", width: 15 },
        { header: "ACAO", key: "acao", width: 8 },
        { header: "CR_ENTIDADE", key: "cr_entidade", width: 20 },
        { header: "CNPJ", key: "cnpj", width: 25 },
        { header: "NOME_ENTIDADE", key: "nome_entidade", width: 45 },
        { header: "CPF_ATIRADOR", key: "cpf", width: 20 },
        { header: "CR_CAC", key: "cr_cac", width: 20 },
        { header: "NOME_ATIRADOR", key: "nome_atirador", width: 25 },
        { header: "DATA_DA_ASSOCIACAO", key: "data", width: 30 },
    ];

    const headerRow = ws.getRow(1);

    headerRow.eachCell((cell) => {
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF00" },
        };

        cell.font = {
            bold: true,
            color: { argb: "000000" },
        };

        cell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
        };
    });

    function limparTexto(valor:string):string {
        return valor.replace(/[.,/-]/g, '');
    }

    const dadosClube =
        {
            cr_number: limparTexto(club?.cr_number),
            cnpj: limparTexto(club?.cnpj),
            nomeClube: club?.fantasia,
        }

    ws.addRows(
        athletes.map((item: any, index: number) => ({
            ord: index + 1,
            acao: item.active == 0 ? 'E' : 'I',
            cr_entidade: dadosClube.cr_number,
            cnpj: dadosClube.cnpj,
            nome_entidade: dadosClube.nomeClube,
            cpf: limparTexto(item.cpf),
            cr_cac: limparTexto(item.cr_number),
            nome_atirador: item.full_name,
            data: item.membership_date
                ? new Date(item.membership_date)
                : ''
        }))
    );

    ws.getColumn(9).numFmt = "dd/mm/yyyy";

    ws.eachRow((row) => {
        row.eachCell((cell) => {
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const periodText =
        filtro?.period?.startDate && filtro?.period?.endDate
            ? `_(${dayjs(filtro.period.startDate).format('DD/MM/YYYY')} - ${dayjs(filtro.period.endDate).format('DD/MM/YYYY')})`
            : '';

    saveAs(new Blob([buffer]), `relatorio_carga_associados${periodText}.xlsx`);
}
